import { forwardRef } from 'react'
import classes from './CommonCard.module.css'

const CommonCard = forwardRef(({children, className, style, onClick}, ref) => {
    return(
        <div className={`${classes.wrapper} ${className}`} style={style} onClick={onClick} ref={ref}>
            {children}
        </div>
    )
})

export default CommonCard